import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchKpiRelationsAction, postKpiAction, postKpisRelationsAction } from 'routes/Performance/modules/actions';

import PerformanceAddComponents from '../components';

function mapStateToProps(state) {
  return {
    lang: state.session.user.lang,
    performance: state.performance,
    literals: state.i18n.literals.performance,
    literalsCommon: state.i18n.literals.common,
    currency: state.global.currency,
    startup: state.global.startup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchKpiRelations: bindActionCreators(fetchKpiRelationsAction, dispatch),
    postKpi: bindActionCreators(postKpiAction, dispatch),
    postKpisRelations: bindActionCreators(postKpisRelationsAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceAddComponents);
